function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Warstwa 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Warstwa 1"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Processing icon",
  d: "M26 9.82V0L13 13.09l13 13.09v-9.82A19.58 19.58 0 0145.5 36a19.31 19.31 0 01-2.28 9.16L48 49.94A26.17 26.17 0 0026 9.82zm0 45.82A19.58 19.58 0 016.5 36a19.32 19.32 0 012.28-9.16L4 22.06a26.17 26.17 0 0022 40.12V72l13-13.09-13-13.09z",
  fill: "#21374d"
})));

function SvgProcessingicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 52.01 72"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1Mi4wMSA3MiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiMyMTM3NGQ7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5aYXPDs2IgMTwvdGl0bGU+PGcgaWQ9IldhcnN0d2FfMiIgZGF0YS1uYW1lPSJXYXJzdHdhIDIiPjxnIGlkPSJXYXJzdHdhXzEtMiIgZGF0YS1uYW1lPSJXYXJzdHdhIDEiPjxwYXRoIGlkPSJQcm9jZXNzaW5nX2ljb24iIGRhdGEtbmFtZT0iUHJvY2Vzc2luZyBpY29uIiBjbGFzcz0iY2xzLTEiIGQ9Ik0yNiw5LjgyVjBMMTMsMTMuMDksMjYsMjYuMThWMTYuMzZBMTkuNTgsMTkuNTgsMCwwLDEsNDUuNSwzNmExOS4zMSwxOS4zMSwwLDAsMS0yLjI4LDkuMTZMNDgsNDkuOTRBMjYuMTcsMjYuMTcsMCwwLDAsMjYsOS44MlptMCw0NS44MkExOS41OCwxOS41OCwwLDAsMSw2LjUsMzZhMTkuMzIsMTkuMzIsMCwwLDEsMi4yOC05LjE2TDQsMjIuMDZBMjYuMTcsMjYuMTcsMCwwLDAsMjYsNjIuMThWNzJMMzksNTguOTEsMjYsNDUuODJaIi8+PC9nPjwvZz48L3N2Zz4=";
export { SvgProcessingicon as ReactComponent };